<body>
  <!--bg start-->
  <div class="bg">
    <!--right bg -->
    <div class="top-bg">
      <img
        src="{{ onPassiveBaseUrl }}onapssive(nov5)/images/top-bg.png"
        alt="top-bg"
        width="100%"
      />
    </div>
    <!--bottom bg -->
    <div class="bottom-bg">
      <img
        src="{{ onPassiveBaseUrl }}onapssive(nov5)/images/bottom-bg.png"
        alt="bottom-bg"
        width="100%"
      />
    </div>
    <h2 class="text-center">
      <span data-text="L">L</span>
      <span data-text="A">A</span>
      <span data-text="U">U</span>
      <span data-text="N">N</span>
      <span data-text="C">C</span>
      <span data-text="H">H</span>
      <span data-text="I">I</span>
      <span data-text="N">N</span>
      <span data-text="G">G</span>
      <span class="mobile-display" data-text="&nbsp;">&nbsp;</span>
      <span data-text="S">S</span>
      <span data-text="O">O</span>
      <span data-text="O">O</span>
      <span data-text="N">N</span>
    </h2>
    <div class="heading">
      <h1 data-text="NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS">
        NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
      </h1>
    </div>
    <div class="container-fluid">
      <div class="row total-div">
        <div class="col-lg-4 hands order-md-2">
          <div class="logo text-center">
            <img src="{{ onPassiveBaseUrl }}onapssive(nov5)/images/logo.png" alt="logo"/>
          </div>
          <div class="left-hand">
            <img
              src="{{ onPassiveBaseUrl }}onapssive(nov5)/images/hand1.png"
              alt="hand1"
              width="100%"
            />
          </div>
          <div class="white-shadow">
            <img
              src="{{ onPassiveBaseUrl }}onapssive(nov5)/images/white-back1.png" alt="white-back1"
            />
          </div>
          <div class="right-hand">
            <img
              src="{{ onPassiveBaseUrl }}onapssive(nov5)/images/hand2.png" alt="hand2"
              width="100%"
            />
          </div>
        </div>
        <div class="col-lg-4 align-self-lg-center order-md-1">
          <!--  video starts -->
          <div class="video">
            <div class="video_box">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
                width="100%"
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <!--  video ends -->
        </div>
        <div class="col-lg-4 align-self-lg-center contents order-md-3">
          <span>H</span>ave you been up and down in life lately? Looking for a
          change in career to land a job that pays well and also keeps you sane
          & happy? Well, look no more. ONPASSIVE is one such business
          opportunity that builds a bridge between you and your ambitious
          dreams. Get on board now, your 'dream come true' life is just one
          click away.
          <br />

          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
          >
            <button class="btn1">Become a Founder</button></a
          >
        </div>
      </div>
    </div>
  </div>
</body>
